import UltMeta, { Meta } from "./UltMeta/index";

// 埋点来源
class ClientType extends UltMeta {
    PC = new Meta(1, "PC");
    APP = new Meta(2, "APP");
    MINI_PROGRAM = new Meta(3, "小程序");
    H5 = new Meta(4, "H5");
    ADMIN = new Meta(5, "管理后台");
}

export const CLIENT_TYPE = new ClientType();

// 埋点来源
class ClientTypeUser extends UltMeta {
    PC = new Meta(1, "PC");
    APP = new Meta(2, "APP");
    MINI_PROGRAM = new Meta(3, "小程序");
}

export const CLIENT_TYPE_USER = new ClientTypeUser();

class ModuleType extends UltMeta {
    COMMODITY_TRADING = new Meta("商品交易", "商品交易");
    // CARGO_FIND_SHIP = new Meta("货找船", "货找船")
    SAND_PRICE = new Meta("查砂价", "查砂价");
    FREIGHT_RATE = new Meta("查运价", "查运价");
    SHIP_QUERY = new Meta("查船舶", "查船舶");
    VEHICLE_QUERY = new Meta("查车辆", "查车辆");
    // FUND_SEARCH = new Meta("找资金", "找资金")
    INFO_CENTER = new Meta("看资讯", "看资讯");
    MINI_CLOUD = new Meta("链小云", "链小云");
    ACTIVITY_ZONE = new Meta("活动", "活动");
    MEMBER = new Meta("会员", "会员");
    OTHER = new Meta("其他", "其他");
}

export const MODULE_TYPE = new ModuleType();

class PinToTop extends UltMeta {
    TOP = new Meta(1, "置顶");
    CANCEL_TOP = new Meta(0, "取消置顶");
}

export const PIN_TO_TP = new PinToTop();
